// extracted by mini-css-extract-plugin
export var active = "_l9-2";
export var recordingDot = "_l9-1";
export var recordingIndicator = "_l9-0";